module.exports = __webpack_public_path__ + "img/arrow-right.6f0f086d.svg";